let lockCount = 0;
let savedScrollY = 0;

/**
 * 锁定页面滚动（支持嵌套弹层引用计数）。
 * 使用 position:fixed 方案，避免 Element Plus lock-scroll 的 padding-right 补偿导致布局抖动。
 */
export function lockBodyScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  lockCount += 1;
  if (lockCount > 1) return;

  savedScrollY = window.scrollY || document.documentElement.scrollTop || 0;

  const { body, documentElement: html } = document;

  body.classList.add('ds-body-scroll-lock');
  html.classList.add('ds-body-scroll-lock');

  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
}

/** 解除页面滚动锁定 */
export function unlockBodyScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (lockCount <= 0) return;

  lockCount -= 1;
  if (lockCount > 0) return;

  const { body, documentElement: html } = document;

  body.classList.remove('ds-body-scroll-lock');
  html.classList.remove('ds-body-scroll-lock');

  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';

  window.scrollTo(0, savedScrollY);
}

/**
 * 强制解除滚动锁（弹层被手动拆 DOM / EP 残留导致计数失真时用）。
 * 仅在确认无其它业务弹层依赖该锁时调用。
 */
export function forceUnlockBodyScroll() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  lockCount = 0;

  const { body, documentElement: html } = document;

  body.classList.remove('ds-body-scroll-lock');
  html.classList.remove('ds-body-scroll-lock');

  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';
  if (body.style.paddingRight) body.style.paddingRight = '';

  window.scrollTo(0, savedScrollY);
}

/**
 * 清掉无内容的 EP 遮罩，以及 el-dialog lock-scroll 残留 class，
 * 避免「关问卷后充值再也点不开」。
 */
export function cleanupOrphanElOverlays() {
  if (typeof document === 'undefined') return;
  try {
    document.querySelectorAll('body > .el-overlay').forEach((node) => {
      const hasContent = node.querySelector(
        '.el-dialog, .el-drawer, .el-message-box, .el-popup, [role="dialog"]'
      );
      if (!hasContent) node.remove();
    });
  } catch {
    /* ignore */
  }

  document.body.classList.remove('el-popup-parent--hidden');
  document.documentElement.classList.remove('el-popup-parent--hidden');
  if (document.body.style.paddingRight) document.body.style.paddingRight = '';
}
